<template>
<!-- v-dialogDrag -->
  <el-dialog
    
    :title="title"
    :modal="modal"
    :show-close="false"
    :append-to-body="true"
    :close-on-click-modal="false"
    :visible.sync="showDialog"
    :width="width"
    @before-close="beforeShut"
    @close="aferClose"
    class="COMMON_VEADIALOG"
  >
    <!-- :close-on-press-escape="false" -->
    <div slot="title" class="reports_title_box">
      <div class="reports_title">
        <template v-if="$slots.title">
          <slot name="title" />
        </template>
        <template v-else>
          <!-- <img v-show="src" :src="src">
          <svg-icon v-show="svg" :icon-class="svg" /> -->
          {{ title }}
        </template>
      </div>
      <div class="reports_title_btn">
        <!-- <div class="help">
          <svg-icon icon-class="wenhao" class="icons" />
        </div> -->
        <i class="el-icon-close" @click="cancelFn" />
      </div>
    </div>
    <!-- 内容 -->
    <slot />
    <!-- 底部 -->
    <div
      v-if="footer"
      slot="footer"
      class="dialog_footer"
      :class="{ small_dialog: small }"
    >
      <!-- 小屏，内容比较少的 -->
      <template v-if="small">
        <el-row>
          <el-col
            :span="24 - 2 * ((typeof small === 'number' && small) || 3)"
            :offset="(typeof small === 'number' && small) || 3"
          >
            <div class="footer_left">
              <slot name="footer-left" />
            </div>
            <div class="footer_btns">
              <template v-if="$slots['footer-right']">
                <slot name="footer-right" />
              </template>
              <template v-else>
                <el-button @click="cancelFn" v-show="showBtn">{{
                  cancelButtonText
                }}</el-button>
                <el-button
                  v-show="showBtn"
                  type="primary"
                  :disabled="disable2submit"
                  :loading="loading"
                  @click="confirm"
                  >{{ confirmButtonText }}</el-button
                >
              </template>
            </div>
          </el-col>
        </el-row>
      </template>
      <!-- 大屏，内容超多的 -->
      <template v-else>
        <div class="footer_left">
          <slot name="footer-left" />
        </div>
        <div class="footer_btns">
          <template v-if="$slots['footer-right']">
            <slot name="footer-right" />
          </template>
          <template v-else>
            <el-button
              @click="cancelFn"
              v-show="showCancelBtn"
              :disabled="cancelAble"
              >{{ cancelButtonText }}</el-button
            >
            <el-button
              v-show="showBtn"
              type="primary"
              :disabled="disable2submit"
              :loading="loading"
              @click="confirm"
              >{{ confirmButtonText }}</el-button
            >
          </template>
        </div>
      </template>
    </div>
  </el-dialog>
</template>
<script>
// import { drag } from '@/assets/js/pubMethods'
export default {
  name: "veaDialog",
  // 自定义指令
  // directives: {
  //   dialogDrag: { bind: drag } // 实现拖拽
  // },
  props: {
    title: {
      // 标题
      type: String,
      default: "",
    },
    footer: {
      // 是否有底部
      type: Boolean,
      default: true,
    },
    modal: {
      // 是否需要蒙层
      type: Boolean,
      default: true,
    },
    // src: { // 标题img图标
    //   type: String,
    //   default: ''
    // },
    // svg: { // 标题svg图标
    //   type: String,
    //   default: ''
    // },
    showBtn: {
      // 是否显示确定按钮
      type: Boolean,
      default: true,
    },
    showCancelBtn: {
      type: Boolean,
      default: true,
    },
    show: {
      // 是否展示弹窗
      type: Boolean,
    },
    beforeClose: {
      // 关闭弹窗前的
      type: Function,
      default: (action, done) => done(),
    },
    cancelButtonText: {
      // 取消按钮文本
      type: String,
      default() {
        return '取消';
      },
    },
    confirmButtonText: {
      // 确认按钮文本
      type: String,
      default() {
        return '保存';
      },
    },
    disable2submit: Boolean, // 禁止 点击提交/确定
    small: {
      // 是否属于小型弹窗 (可传入数字来确定el-col的offset的值)
      type: [Boolean, Number],
      default: false,
    },
    cancelAble: {
      type: Boolean,
      default: false,
    },
    width: {
      // 宽度
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showDialog: true,
      loading: false,
      notEscape: false, // 不是按键盘esc键关闭的
    };
  },
  watch: {
    show: {
      handler(n, o) {
        this.showDialog = n;
        if (n === true) {
          this.notEscape = false; // 置为默认值
        }
      },
      immediate: true,
    },
    showDialog(n) {
      if (!n) {
        this.loading = false; // 关闭弹窗，取消loading
        this.$emit("update:show", false); // ps: +2020.10.27 后期使用就可以通过:show.sync=""实现子组件更新父组件传入的props（show）值
      }
    },
  },
  methods: {
    // 右上角 关闭按钮 点击事件（请研究一下怎么传两个参数给父组件 action，done 类似 vantui 的dailog）
    cancelFn() {
      this.b4close("cancel");
    },
    confirm() {
      this.loading = true;
      this.b4close("confirm");
    },
    // 暴露一个close()方法给父组件调用关闭
    close() {
      this.showDialog = false;
    },
    // 点击右上角关闭按钮
    beforeShut(done) {
      this.b4close("cancel");
    },
    // 关闭弹窗前的操作 @todo 待完善
    async b4close(action) {
      this.notEscape = true;
      await this.beforeClose(action, this.close);
      this.loading = false;
    },
    // Dialog 关闭的回调
    aferClose() {
      // 防止用户直接按下esc关闭弹窗后不会更新show值
      if (!this.notEscape) {
        this.b4close("cancel", this.close);
      }
      this.$emit("aferClose")
    },
  },
};
</script>
<style lang="scss">
@import "@/styles/mixin.scss";
.COMMON_VEADIALOG {
  @include cannotchoose;
  .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    @include center;
    // 表头
    .el-dialog__header {
      height: 46px;
      padding: 0;
      // color: #fff;
      .reports_title_box {
        padding: 0 16px;
        // background: $active-color;
        display: flex;
        justify-content: space-between;
        align-items: center;
        @include font(16px, 46px);
        position: relative;
        &::before {
          // 底边
          content: "";
          display: block;
          width: calc(100% - 32px);
          position: absolute;
          bottom: 0;
          height: 1px;
          background: #f8f8f8;
          transform: rotateX(15deg);
        }
        .reports_title {
          display: flex;
          align-items: center;
          font-weight: bold;
          img {
            @include wh(24px, 24px);
            margin-right: 6px;
          }
          svg {
            color: $active-color;
          }
        }
        .reports_title_btn {
          display: flex;
          align-items: center;
          .help,
          .el-icon-close {
            padding: 0 5px;
            @include font(14px, 46px);
            cursor: pointer;
            font-weight: bold;
          }
        }
      }
    }
    // 主体
    .el-dialog__body {
      padding: 0;
      padding-top: 25px;
      flex: 1;
    }
    // 尾部
    .el-dialog__footer {
      height: 70px;
      padding: 0;
      .footer_search_box {
        @include wh(154px, 24px);
        .el-input {
          .el-input__suffix {
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
      .dialog_footer {
        padding: 0 25px;
        @include wh(100%, 70px);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-row {
          width: 100%;
        }
        .footer_left {
        }
        .footer_btns {
          // margin-right: 40px; // 这里加了margin 会直接影响到其他模块使用，不能在这里加
          .el-button {
            min-width: 70px;
            padding: 0;
            line-height: 30px;
          }
        }
      }
      // 针对小屏（内容少的弹窗，底部采用栅格布局）
      .small_dialog {
        padding: 0;
      }
    }
  }
}
// 媒体查询 @1440px
@media screen and (max-width: 1440px) {
  .COMMON_VEADIALOG {
    .el-dialog {
      .el-dialog__header {
        height: 44px;
        .reports_title_box {
          padding: 0 16px;
          .reports_title {
            @include font(20px, 44px);
            font-weight: bold;
            .svg-icon {
              font-size: 22px;
            }
          }
          .reports_title_btn {
            // .help {
            //   line-height: 36px;
            // }
            .el-icon-close {
              font-weight: bold;
              line-height: 44px;
            }
          }
        }
      }
      .el-dialog__footer {
        height: 56px;
        .dialog_footer {
          height: 56px;
          .footer_btns {
          }
        }
      }
    }
  }
}
</style>
